export default __webpack_public_path__ + "static/media/THSarabun-Italic.f3201142.ttf";